$(document).ready(function() {
    const STORAGE_KEYS = {
        SETTING_INFORMATION: "setting-information",
        CUSTOM_RING_STEP: "customRingStep"
    };
    const settingProductArray = {};
    $(document).on("click", ".explore-more-diamonds-button", function () {
        const $container = $(".product__info-container");
        const variantShape = $container.find(".diamond-shape input:checked").val();
        const variantColor = $container.find(".metal-color input:checked").val();
        const preset_id = $container.find('[name="id"]').val();
        const variant_image = $('#product-form-variants option[value="' + preset_id + '"]').data("variant-featured-img");

        const setting_product_info = $(".ring-setting-information>div");
        const title = setting_product_info.data("product-title");

        let product_price;
        let product_compare_price;
        let product_price_formatted;
        let product_compare_price_formatted;
        let variantId;
        const product_shape_array = [];
        const selected_metal_color_variant_obj = {};
        const setting_variant_list = JSON.parse($("#setting_variant-json").text() || "{}");

        Object.entries(setting_variant_list).forEach(function([key, value]) {
            if (key.indexOf(variantShape) > -1 && key.indexOf(variantColor) > -1) {
                variantId = value.id;
                product_price = value.price;
                product_price_formatted = value.price_formatted;
                product_compare_price = value.compare_price || 0;
                product_compare_price_formatted = value.compare_price_formatted;
            }
            const color_name = value.color;
            const shape_name = value.shape;
            if (variantColor.indexOf(color_name) > -1 && product_shape_array.indexOf(shape_name) < 0) {
                selected_metal_color_variant_obj[shape_name] = value.id;
                product_shape_array.push(shape_name);
            }
        });

        const settingUrl = "/products/" + setting_product_info.data("setting-handle");

        settingProductArray.url = settingUrl;
        settingProductArray.title = title;
        settingProductArray.price = product_price;
        settingProductArray.compare_price = product_compare_price;
        settingProductArray.price_formatted = product_price_formatted;
        settingProductArray.compare_price_formatted = product_compare_price_formatted;
        settingProductArray.selected_variant = variantId;
        settingProductArray.variants = selected_metal_color_variant_obj;
        settingProductArray.shape = variantShape;
        settingProductArray.image = variant_image;
        settingProductArray.tags = setting_product_info.data("product-tags");

        console.log("settingProductArray",settingProductArray); 

        localStorage.setItem(STORAGE_KEYS.SETTING_INFORMATION, JSON.stringify(settingProductArray));

        sessionStorage.removeItem("click_on_continue");
        window.location.href = "/collections/lab-grown-diamonds";

        return false;
    });
});